import { render } from "./guestForm.vue?vue&type=template&id=53859ba8"
import script from "./guestForm.vue?vue&type=script&lang=js"
export * from "./guestForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__